/*global GetAppInfo, MOMReportEnum, TTTimeUnitEnum, MakeTextRequestURL, TTApplicationEnum, _moovilaSecurity */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import validator from 'validator';

import { showMessageBox } from '../../actions';

import reportConfig, { SCFUsageCode } from '../../constants/reportConfig';
import ConfigureStartDateReport from '../../components/Reports/ConfigureStartDateReport'

const today = moment();

class ConfigureSCUsageReportContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: false,
            report: null,
            startDate: '',
            userInput: false,
        };
        this.onChange = this.onChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        const report = reportConfig.filter(report => report.code === SCFUsageCode)[0];
        if (!report) {
            this.setState({
                redirect: true,
            });
            return;
        }
        this.setState({
            report,
        })
    }

    onChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({
            [name]: value,
        });
    }

    openReport() {


        const reportParms = {
            startDate: moment(this.state.startDate).format(),
            enterpriseGUID: _moovilaSecurity.GetEnterpriseGUID()

        };

        var strURL = MakeTextRequestURL("Reporting", "ExecuteSCUsageReport", JSON.stringify(reportParms));
        window.open(strURL, "_blank");
        this.setState({ redirect: true });
    }

    validate() {
        let message = '';
        if (!this.state.startDate.length) {
            message = 'Please provide a start date';
        } else if (!validator.isISO8601(moment(this.state.startDate).format())) {
            message = 'Please provide a valid start date';
        }

        if (message) {
            this.props.showMessageBox({
                'title': 'Invalid Entry',
                message,
            });
            return false;
        }
        return true;
    }

    handleSubmit(e) {
        if (!this.validate()) {
            e.preventDefault();
            return;
        }
        this.openReport();
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to="/home" />;
        }
        return (
            <ConfigureStartDateReport
                reportName={this.state.report.name}
                startDate={this.state.startDate}
                handleSubmit={this.handleSubmit}
                onChange={this.onChange}
                path={''}
            />
        );
    }
}

export default connect(s => s, {
    showMessageBox,
})(ConfigureSCUsageReportContainer);


// WEBPACK FOOTER //
// ./src/containers/Reports/ConfigureSCUsageReport.js